import { z } from "zod";

export const customerSchema = z.object({
  id: z.number(),
  name: z.string(),
  email_address: z.string().optional().nullable(),
  phone_number: z.string().optional().nullable(),
  street: z.string().optional().nullable(),
  house_number: z.string().optional().nullable(),
  house_number_addition: z.string().optional().nullable(),
  postal_code: z.string().optional().nullable(),
  city: z.string().optional().nullable(),
  country: z.string().optional().nullable(),
  relation_id: z.number(),
});

export type CustomerModel = z.infer<typeof customerSchema>;

export const customerColumns = [
  {
    accessorKey: "name",
    header: "Name",
  },
];
